import { useState, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { routes } from "./routes/routes";
import { SocketContext } from "./context/SocketContext";

function getSelectRole(roleObj) {
  const rights = roleObj?.rights || [];
  const subRights = rights.find((r) => r.menu === "Select")?.subRights || [];
  const hasAccess = subRights.some((sub) => {
    const name = sub.subMenu?.toLowerCase().trim();
    return (
      ["binny's select access", "is stock manager"].includes(name) &&
      sub.permissions?.some((per) => per.allowed)
    );
  });
  if (!hasAccess) return null;
  const isAdmin = subRights
    .find((sub) => sub.subMenu === "Binny's Select Access")
    ?.permissions?.some((per) => per.allowed);
  return isAdmin ? "Admin" : "Stock Manager";
}

function App({ socket }) {
  const [ssoLoading, setSsoLoading] = useState(!localStorage.getItem("token"));

  // useEffect(() => {
  //   const baseUrl = process.env.REACT_APP_SOCKET_SERVER_URL;

  //   if (localStorage.getItem("token")) { setSsoLoading(false); return; }

  //   const handleSsoLogin = async () => {
  //     try {
  //       const res = await fetch(`${baseUrl}/api/v1/users/me`, { credentials: "include" });
  //       if (res.ok) {
  //         const result = await res.json();
  //         if (result?.token) {
  //           const selectRole = getSelectRole(result.role);
  //           if (!selectRole) return;
  //           localStorage.setItem("token", result.token);
  //           localStorage.setItem("role", selectRole);
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Auto-login failed:", err);
  //     } finally {
  //       setSsoLoading(false);
  //     }
  //   };

  //   handleSsoLogin();
  // }, []);

  // if (ssoLoading) return null;

  return (
    <SocketContext.Provider value={socket}>
      <RouterProvider router={routes} />
    </SocketContext.Provider>
  );
}

export default App;
